import _ from "lodash";
import update from "immutability-helper";
import client from "lib/apolloClient/client";
import {
  editUserMutation,
  addUserMutation,
} from "QueryMutationFragment/CommonQueryMutationFragment/mutations";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { getStudentFeedQuery } from "StudentSetup/modules/StudentQueries";
import {
  getAdminSetupFiltersByEntityTypeMemoized,
  ADMIN_SEARCH_TEXT_FIELDS,
  getUserCourseMapFiltersV2,
} from "Administrator/modules/Utils";
import {
  getCurriculumProgramId,
  getStaffFilter,
} from "StudentSetup/modules/StudentsModule";
import { getSelectedAcademicYearId } from "SchoolSetup/modules/Utils";
import { getIsMultipleHomeroomAdvisorsEnabled } from "Utils/ACLStoreUtils";

// Constants
export const NAME = "createStudent";
export const UPDATE_STUDENT_OBJECT = "UPDATE_STUDENT_OBJECT" + " " + NAME;
export const INIT_STUDENT_OBJECT = "INIT_STUDENT_OBJECT" + " " + NAME;
export const UPDATE_STUDENT_STEP = "UPDATE_STUDENT_STEP" + " " + NAME;
// Actions Creator
export const updateStudentObject = data => {
  return {
    type: UPDATE_STUDENT_OBJECT,
    payload: data,
  };
};
export const initStudentObject = () => {
  return {
    type: INIT_STUDENT_OBJECT,
  };
};

export const updateStudentStep = data => {
  return {
    type: UPDATE_STUDENT_STEP,
    payload: data,
  };
};

// THUNKS

export const onContentUploaded = values => {
  return (dispatch, getState) => {
    dispatch(updateStudentObject({ profileImage: values }));
  };
};

export const createStudent = () => {
  return async (dispatch, getState) => {
    const organizationId = getState().login.userInfo.org_id;
    const studentDetails = getState().createStudent.studentDetails;
    const courses = getState().adminCommon.selectedList.courses.map(
      student => student.id
    );
    const { orderByDirection, orderBy } = _.get(
      getState().app_services,
      "orderByDirectionObj.adminStudentFeed",
      {}
    );
    const searchText = getState().studentSetup.searchText;
    const filters = getState().studentSetup.filters;
    const curriculumProgramId = getCurriculumProgramId(getState());
    const courseTagMap = [];
    _.forOwn(studentDetails.courseTagMap, (value, key) => {
      const subjectLevelId = _.get(value, "value");
      courseTagMap.push({ courseId: key, subjectLevelId });
    });
    const sendCourseTagMap = !_.isEmpty(courseTagMap);

    const userCourseMapFilters = getUserCourseMapFiltersV2({
      archivalState: "ALL",
    });
    try {
      if (studentDetails.sourceId === "") studentDetails.sourceId = null;
      await client.mutate({
        mutation: addUserMutation,
        variables: {
          email: studentDetails.email,
          userType: "student",
          firstName: studentDetails.firstName,
          lastName: studentDetails.lastName,
          profileImage: studentDetails.profileImage,
          sourceId: studentDetails.sourceId,
          registrationCategory: studentDetails.registrationCategory,
          yearGroupId: studentDetails.yearGroup,
          courseTagMap,
          staffRelationMap: !getIsMultipleHomeroomAdvisorsEnabled()
            ? !_.isEmpty(studentDetails?.homeroomTeacherId)
              ? [
                  {
                    relation: "HOMEROOM",
                    staffId: _.get(studentDetails, "homeroomTeacherId", null),
                  },
                ]
              : []
            : !_.isEmpty(studentDetails?.homeroomTeacherIds)
            ? _.map(studentDetails.homeroomTeacherIds, id => ({
                relation: "HOMEROOM",
                staffId: id,
              }))
            : [],
          ...(sendCourseTagMap ? { courseTagMap } : { courses }),
          //commenting it because we don't need curriculum any more to create student
          // curriculumProgramId
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: getStudentFeedQuery,
            variables: {
              organizationId,
              userCourseMapFilters,
              filters: getAdminSetupFiltersByEntityTypeMemoized({
                type: "STUDENT",
                searchText,
                courses: filters["courses"],
                archivalState: filters["archivalState"],
                searchTextFields: ADMIN_SEARCH_TEXT_FIELDS["student"],
                curriculumProgramId,
                yearGroups: filters["yearGroups"],
                academicYearId: getSelectedAcademicYearId(getState()),
              }),
              orderByDirection,
              orderBy,
              staffFilter: getStaffFilter({
                id: getSelectedAcademicYearId(getState()),
              }),
              withStaffRelation: true,
            },
          },
        ],
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:successfully_with_label",
          locale_params: [
            { key: "label", value: "toastMsgs:updated", isPlainText: false },
          ],
          type: "success",
          position: "toast-bottom-left",
        })
      );
    } catch (err) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      throw err;
    }
  };
};

export const updateStudentDetails = () => {
  return async (dispatch, getState) => {
    const organizationId = getState().login.userInfo.org_id;
    const studentDetails = getState().createStudent.studentDetails;
    const { orderByDirection, orderBy } = _.get(
      getState().app_services,
      "orderByDirectionObj.adminStudentFeed",
      {}
    );
    const searchText = getState().studentSetup.searchText;
    const filters = getState().studentSetup.filters;
    const curriculumProgramId = getCurriculumProgramId(getState());
    const userCourseMapFilters = getUserCourseMapFiltersV2({
      archivalState: "ALL",
    });

    try {
      if (studentDetails.sourceId === "") studentDetails.sourceId = null;
      const response = await client.mutate({
        mutation: editUserMutation,
        variables: {
          id: studentDetails.id,
          firstName: studentDetails.firstName,
          lastName: studentDetails.lastName,
          profileImage: studentDetails.profileImage,
          email: studentDetails.email,
          sourceId: studentDetails.sourceId,
          registrationCategory: studentDetails.registrationCategory,
          yearGroupId: studentDetails.yearGroup,
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: getStudentFeedQuery,
            variables: {
              organizationId,
              userCourseMapFilters,
              userArchivedFilters: {
                academicYearId: getSelectedAcademicYearId(getState()),
              },
              filters: getAdminSetupFiltersByEntityTypeMemoized({
                type: "STUDENT",
                searchText,
                courses: filters["courses"],
                archivalState: filters["archivalState"],
                searchTextFields: ADMIN_SEARCH_TEXT_FIELDS["student"],
                curriculumProgramId,
                yearGroups: filters["yearGroups"],
              }),
              orderByDirection,
              orderBy,
              staffFilter: getStaffFilter({
                id: getSelectedAcademicYearId(getState()),
              }),
              withStaffRelation: true,
            },
          },
        ],
      });

      setToastMsg({
        type: "success",
        msg: "toastMsgs:saved_successfully",
      });

      return _.get(response, "data.platform.updateUserV2", {});
    } catch (err) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      throw err;
    }
  };
};

// Reducers
const REDUCER_HANDLERS = {
  [UPDATE_STUDENT_OBJECT]: (state, action) => {
    const params = action.payload;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        studentDetails: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },
  [INIT_STUDENT_OBJECT]: (state, action) => {
    return update(state, {
      studentDetails: { $set: initialState.studentDetails },
    });
  },
  [UPDATE_STUDENT_STEP]: (state, action) => {
    return update(state, { studentStep: { $set: action.payload } });
  },
};

// Export Reducer
const initialState = {
  studentDetails: {
    id: null,
    firstName: "",
    profileImage: null,
    lastName: "",
    email: "",
    sourceId: "",
    registrationCategory: null,
    yearGroup: null,
    courseTagMap: {},
    curriculum: "",
    homeroomTeacherId: null,
    homeroomTeacherIds: [],
  },
  studentStep: 1,
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
